<template>
    <properties-block  v-bind="$props" v-on="$listeners">
        <properties-component-text title="Question|Question" :value="block.question" v-bind="componentProps"/>
        <properties-component-text title="Answer|Réponse" :value="block.answer" v-bind="componentProps"/>
    </properties-block>
</template>

<script>
import PropertiesComponentText from "@/components/editor/properties/components/properties-component-text.vue";
import PropertiesBlock from "@/components/editor/properties/blocks/properties-block.vue";

// properties-block-faq-item #hot-reload-debug
export default {
    name: `properties-block-faq-item`,
    components: {PropertiesComponentText, PropertiesBlock},
    extends: PropertiesBlock
}
</script>

<style lang="scss" scoped>
</style>
